export default "__VITE_ASSET__DWIPIZt6__"